import * as api from '../../services/evt'
import omit from 'lodash/omit';
import lodash from 'lodash'

export const FETCH_EVTS = 'FETCH_EVTS';
export const FETCH_EVT = 'FETCH_EVT';
export const FETCH_OPERTION_EVT = 'FETCH_OPERTION_EVT';
export const STORE_EVTS_COLUMNS = 'SET_EVTS_COLUMNS';
export const REPLACE_EVT_IN_EVTS = 'REPLACE_EVT_IN_EVTS';
export const WX_LEVEL_SHARE_ATTENDEES = 'WX_LEVEL_SHARE_ATTENDEES';
export const FETCHLEVELSHARE = 'FETCHLEVELSHARE';
export const FETCHLEVELSHARETWO = 'FETCHLEVELSHARETWO';
export const FETCH_WXLEVELSHARESTATIS = 'FETCH_WXLEVELSHARESTATIS';
export const FETCH_CHECKINCREDIT = 'FETCH_CHECKINCREDIT';
export const FETCH_CODESHARES = 'FETCH_CODESHARES';
export const FETCH_GUESTGROUPS = 'FETCH_GUESTGROUPS';
export const FETCH_EVENTGROUPS = 'FETCH_EVENTGROUPS';
export const FETCH_EVENTCOMMENTPAGES = 'FETCH_EVENTCOMMENTPAGES';
export const FETCH_EVENTCOMMENTS = 'FETCH_EVENTCOMMENTS';


export const fetchEvt = (id) => {
    return {
        type: FETCH_EVT,
        payload: {
            promise: api.findEvent({id: id})
        }
    }
}


export const fetchEvtWithViewedCounted = (id) => {
    return {
        type: FETCH_EVT,
        payload: {
            promise: api.findEventWithViewedCounted({id: id})
        }
    }
}


export const storeEvtsColumns = (columns) => ({type: STORE_EVTS_COLUMNS, columns});

export const replaceEvtInEvts = (evtId, evt) => {
    return {
        type: REPLACE_EVT_IN_EVTS,
        evtId,
        evt,
    }
};
export const addWxLevelShareAttendees = (data=[]) => {
    return {
        type: WX_LEVEL_SHARE_ATTENDEES,
        data,
    }
};
export const fetchPublishedEvts = (params, pagination, sort, extra) => {
    const _params = Object.assign(params, {"published": true})
    return fetchEvts(_params, pagination, sort, extra);
}

export const fetchUnpublishedEvts = (params, pagination, sort, extra) => {
    const _params = Object.assign(params, {"published": false})
    return fetchEvts(_params, pagination, sort, extra);
}

export const fetchEvts = (params, pagination, sort, extra) => {
    return {
        type: FETCH_EVTS,
        payload: {
            promise: api.findEvents(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'ownership','idOrName','happenStatus','uniqueFieldValue','guestGroupIds'),
            sort: sort,
            extra: extra
        }
    }
}

export const fetchOperationEvts = (params, pagination, sort, extra) => {
    return {
        type: FETCH_OPERTION_EVT,
        payload: {
            promise: api.findOperationEvents(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}
export const fetchEventWxLevelShare = (params, pagination, sort, extra) => {
    return {
        type: FETCHLEVELSHARE,
        payload: {
            promise: api.findEventWxLevelShare(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'levelOne','nickname'),
            sort: sort,
            extra: extra
        }
    }
}
export const fetchEventWxLevelShareTwo = (params, pagination, sort, extra) => {
    return {
        type: FETCHLEVELSHARETWO,
        payload: {
            promise: api.findEventWxLevelShare(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'levelOne','nickname'),
            sort: sort,
            extra: extra
        }
    }
}
export const fetchEventWxLevelShareStatis = (params, pagination, sort, extra) => {
    return {
        type: FETCH_WXLEVELSHARESTATIS,
        payload: {
            promise: api.findEventWxLevelShareStatis(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}
export const fetchEventCheckinCredits = (params, pagination, sort, extra) => {
    return {
        type: FETCH_CHECKINCREDIT,
        payload: {
            promise: api.findEventCheckinCredits(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}
export const fetchEvenCodeShares= (params, pagination, sort, extra) => {
    return {
        type: FETCH_CODESHARES,
        payload: {
            promise: api.findEvenCodeShares(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}
export const fetchGuestGroups= (params, pagination, sort, extra) => {
    return {
        type: FETCH_GUESTGROUPS,
        payload: {
            promise: api.findGuestGroups(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}
export const fetchEventGroups= (params, pagination, sort, extra) => {
    return {
        type: FETCH_EVENTGROUPS,
        payload: {
            promise: api.findEventGroups(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}
export const fetchEventCommentPages= (params, pagination, sort, extra) => {
    return {
        type: FETCH_EVENTCOMMENTPAGES,
        payload: {
            promise: api.findEventCommentPages(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}
export const fetchEventComments= (params, pagination, sort, extra) => {
    return {
        type: FETCH_EVENTCOMMENTS,
        payload: {
            promise: api.findEventComments(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}




// WEBPACK FOOTER //
// ./src/redux/actions/evt.js